import { isRevampJourneyPhoto } from '../constants/AppConstants';

export const closeVideoModalRevamp = (
   { args, onUserAction, additionalData, getState }: any,
   callback: any
) => {
   const { storeValues } = getState();
   const { siNumberStatusDetails } = storeValues ?? {};
   const { actionRequired = 'FULL_KYC' } = siNumberStatusDetails || {};

   const isClosedWithoutUpload = args?.[0] === 'closeWithoutUpload';
   const isNewSKYCJourney = storeValues?.journeyContext?.journey === 'SKYC_NEW';
   const isRevamp = isRevampJourneyPhoto();
   let isSuccess;

   // if (isNewSKYCJourney) {
      isSuccess = additionalData?.dataFromWidget?.response?.status === '200';
   // } else {
   //    isSuccess = additionalData?.dataFromWidget?.response?.status?.code === '200';
   // }
   isSuccess = isSuccess || isClosedWithoutUpload;
   console.log("closeVideoModalRevamp additionalData?.dataFromWidget?.response?.statu>>>",additionalData?.dataFromWidget?.response?.status)
   const actions: any[] = [];

   if (isSuccess) {
      callback();
      if (!isClosedWithoutUpload) {
      
            actions.push({
               type: 'navigation',
               payload: {
                  screenName: '/disability',
                  type: 'push',
                  shouldAddSearchParams: true,
                  params: {
                     screenQueryParams: {
                      
                     },
                  },
               },
            });
      
      }
   } else {
    
         actions.push({
            analyticsAction: 'impression',
            analyticsData: {
               eventCategory: 'NEW_ACQ_POSTPAID_SKYC',
               section: 'stepsSection',
               subSection: 'Step5Widget',
               eventAction: 'impression',
               eventLabel: 'submit',
               eventValue: '',
               customValue: 'Video cannot be submitted',
               customLabel: 'button',
               prop35: '{{storeValues:orderData.orderData.cartId}}',
               extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
               prop45: '{{storeValues:appData.subJourney}}',
               eVar21: '{{storeValues:appData.loggedInNumber}}',
               eVar36: '{{storeValues:appData.msisdn}}',
               city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
               eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
               prop4: 'SKYC',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop7: '{{storeValues:outstationContext.isOutstation}}',
               prop9: '{{storeValues:appData.lob}}',
               eVar10: 'error',
            },
         });
      
      onUserAction({
         actions: [
            {
               type: 'showToast',
               payload: {
                  title: 'something went wrong please try again',
                  dismissDuration: 5000,
                  position: 'bottom-center',
                  state: 'error',
                  style: {
                     zIndex: 10000,
                  },
               },
            },
         ],
      });
   }

   onUserAction({
      actions,
   });
};
